import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import styles from "./Button.module.scss";

const Button = ({ children, className, onClick, disabled, type }) => {
  return (
    <button
      type={type}
      className={cx({ [styles.disabled]: disabled }, className)}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  className: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default Button;
